'use client';

import { ListItem } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

type CellProps = { children: ReactNode };

const Cell = ({ children }: CellProps) => (
  <ListItem
    py={200}
    px={300}
    sx={theme => ({
      minWidth: '18.5rem',
      '&:first-of-type:not(:only-of-type)': { backgroundColor: theme.color.background.secondary }
    })}
  >
    {children}
  </ListItem>
);

export default Cell;
